import { questionConstants } from "../../../constants/question/question.constants";
import { deepClone } from "../../../helpers/objectHelper";

export function question(state = {}, action) {
    switch (action.type) {
        case questionConstants.GET_QUESTION_BY_EVENT_REQUEST:
            return { ...state, loading: true };
        case questionConstants.GET_QUESTION_BY_EVENT_SUCCESS:
            return { ...state, loading: false, questions: action.questions };
        case questionConstants.GET_QUESTION_BY_EVENT_FAILURE:
            return { ...state, loading: false, error: action.error };
        case questionConstants.DELETE_QUESTIONS_REQUEST:
            return { ...state, loading: true };
        case questionConstants.DELETE_QUESTIONS_SUCCESS:
            return { ...state, loading: false, questions: state.questions.filter(q => q.questionId !== action.questionId) };
        case questionConstants.DELETE_QUESTIONS_FAILURE:
            return { ...state, loading: false, error: action.error };
        case questionConstants.UPDATE_QUESTIONS_REQUEST:
            return { ...state, loading: true };
        case questionConstants.UPDATE_QUESTIONS_SUCCESS:
            return { ...state, loading: false, questions: action.questions };
        case questionConstants.GET_QUESTIONS_BY_EVENT_FAILURE:
            return { ...state, loading: false, error: action.error };
        case questionConstants.UPDATE_QUESTION_REQUEST:
            return { ...state, loading: true };
        case questionConstants.UPDATE_QUESTION_SUCCESS:
            let questions = state.questions.map(q => {
                if (q.questionId === action.question.questionId) {
                    return deepClone(action.question);
                }
                else {
                    return deepClone(q);
                }
            });

            return { ...state, loading: false, questions };
        case questionConstants.GET_QUESTION_BY_EVENT_FAILURE:
            return { ...state, loading: false, error: action.error };
        case questionConstants.CREATE_QUESTION_REQUEST:
            return { ...state, loading: true };
        case questionConstants.CREATE_QUESTION_SUCCESS:
            return { ...state, loading: false, questions: [...state.questions, action.question] };
        case questionConstants.CREATE_QUESTION_FAILURE:
            return { ...state, loading: false, error: action.error };
        default:
            return state;
    }
}
